import { render } from "./Create.vue?vue&type=template&id=efefe16e"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/ItemLocations/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "efefe16e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('efefe16e', __exports__)) {
    console.log('reload')
    api.reload('efefe16e', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=efefe16e", () => {
    console.log('re-render')
    api.rerender('efefe16e', render)
  })

}


export default __exports__